import { onReady } from "/Assets/js/utilities.js";

export default class SiteSearch {

    constructor() {
        const siteSearchCntnr = document.querySelector(".site-search");
        this.siteSearchCntnr = siteSearchCntnr;
        const mobileSiteSearchCntnr = document.querySelector(".site-search-mobile");
        this.mobileSiteSearchCntnr = mobileSiteSearchCntnr;
    }

    init() {
        onReady(() => {
            if (!this.siteSearchCntnr && !this.mobileSiteSearchCntnr)
                return;

            this.bindEvents();
        });
    }

    bindEvents() {
        var self = this;

        // desktop search events
        const siteSearchOpenButton = document.querySelector(".site-search-open");
        if (siteSearchOpenButton) {
            self.siteSearchOpenButton = siteSearchOpenButton;

            // open search
            self.siteSearchOpenButton.addEventListener("click", () => {
                document.querySelector(".main-nav-bar").classList.remove("is-visible");
                self.siteSearchCntnr.classList.add("is-visible");
            });

            // close search
            self.siteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".search-input-wrapper-close")) return;
                event.preventDefault();
                document.querySelector(".main-nav-bar").classList.add("is-visible");
                self.siteSearchCntnr.classList.remove("is-visible");
            }, false);
        }

        const searchInput = self.siteSearchCntnr.querySelector("input.search");
        if (searchInput) {
            self.searchInput = searchInput;

            // clear search input
            self.siteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".clear-search")) return;
                event.preventDefault();
                self.searchInput.value = "";
                self.siteSearchCntnr.querySelector(".form-control-clear").classList.add("is-hidden");
            }, false);

            // show search input clear button
            self.searchInput.addEventListener("input", () => {
                self.siteSearchCntnr.querySelector(".form-control-clear").classList.remove("is-hidden");
            });
        }

        // mobile search events
        var searchInputOptions = document.querySelector(".search-input-mobile");
        if (searchInputOptions) {
            self.searchInputOptions = searchInputOptions;

            // show search options
            self.mobileSiteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".search")) return;
                event.preventDefault();
                self.showSearchOptions();
            });

            // change search option
            self.mobileSiteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".dropdown li")) return;
                event.preventDefault();
                self.changeSearchOption(event.target);
            });
        }

        const mobileSearchInput = self.mobileSiteSearchCntnr.querySelector("input.search");
        if (mobileSearchInput) {
            self.mobileSearchInput = mobileSearchInput;

            // clear mobile search input
            self.mobileSiteSearchCntnr.addEventListener("click", (event) => {
                if (!event.target.closest(".clear-search")) return;
                event.preventDefault();
                self.mobileSearchInput.value = "";
                self.mobileSiteSearchCntnr.querySelector(".form-control-clear").classList.add("is-hidden");
            }, false);

            // show mobile search input clear button
            self.mobileSearchInput.addEventListener("input", () => {
                self.mobileSiteSearchCntnr.querySelector(".form-control-clear").classList.remove("is-hidden");
            });

            // listen for keypress submit
            self.mobileSearchInput.addEventListener("keydown", (event) => {
                var deviceMode = event.target.getAttribute("quick-search-input-name");
                if (event.which == 13) {
                    var inputValue = event.target.value;

                    if (inputValue != "") {
                        const urlElement = document.querySelector("[quick-search-container] [quick-search-select-option=\"" + deviceMode + "\"] li.active");
                        const url = urlElement.getAttribute("search-url");
                        window.location.href = url + inputValue;
                    }
                }
            });

            // listen for click submit
            const mobileSearchButton = self.mobileSiteSearchCntnr.querySelector("[quick-search-btn]");
            self.mobileSearchButton = mobileSearchButton;
            self.mobileSearchButton.addEventListener("click", () => {
                var deviceMode = self.mobileSearchButton.getAttribute("quick-search-input-name");
                var inputValue = self.mobileSearchInput.value;

                if (inputValue != "") {
                    const urlElement = document.querySelector("[quick-search-container] [quick-search-select-option=\"" + deviceMode + "\"] li.active");
                    const url = urlElement.getAttribute("search-url");
                    window.location.href = url + inputValue;
                }
            });
        }
    }

    changeSearchOption(element) {
        const self = this;

        const dropdown = self.searchInputOptions.querySelector("ul.dropdown");
        const dropdownItems = dropdown.querySelectorAll("li");

        if (!dropdownItems) return;
        [].forEach.call(dropdownItems, function (item) {
            item.classList.remove("active");
        });

        let target = element;
        if (element.matches("a")) {
            target = element.parentNode;
        }
        target.classList.add("active");
    }

    showSearchOptions() {
        const self = this;
        var dropdown = self.searchInputOptions.querySelector("ul.dropdown");
        dropdown.classList.add("is-visible");
    }

    hideSearchOptions() {
        const self = this;
        var dropdown = self.searchInputOptions.querySelector("ul.dropdown");
        dropdown.classList.remove("is-visible");
    }
}
